import { hasAnyContent, removeLines } from "@/mk2/helpers/article_ast/utils";
import { cacheLast } from "@/mk2/helpers/cache";
import { AST, ContentItemEntity } from "@/mk2/schemas";

const changedContentASTCache = cacheLast(true);

export function removeLinesWithLinksToArticle(
    backlinksBox: ContentItemEntity,
    articleIds: number[],
): ContentItemEntity {
    const removeCondition = (ast: AST) =>
        ast.type === "link_to_object" &&
        ast.obj_schema_key === "wiki.article" &&
        articleIds.includes(ast.obj_id);
    const contentAST = changedContentASTCache(
        () => removeLines(backlinksBox.contentAST, removeCondition),
        backlinksBox,
        articleIds,
    );
    return hasAnyContent(contentAST)
        ? {
              ...backlinksBox,
              contentAST,
          }
        : null;
}
